var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetaEsquerda(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7231 11.0269C33.5367 11.8405 33.5367 13.1595 32.7231 13.9731L21.6962 25L32.7231 36.0269C33.5367 36.8404 33.5367 38.1595 32.7231 38.9731C31.9095 39.7867 30.5904 39.7867 29.7768 38.9731L17.2768 26.4731C16.4632 25.6595 16.4632 24.3404 17.2768 23.5269L29.7768 11.0269C30.5904 10.2133 31.9095 10.2133 32.7231 11.0269Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7231 11.0269C33.5367 11.8405 33.5367 13.1595 32.7231 13.9731L21.6962 25L32.7231 36.0269C33.5367 36.8404 33.5367 38.1595 32.7231 38.9731C31.9095 39.7867 30.5904 39.7867 29.7768 38.9731L17.2768 26.4731C16.4632 25.6595 16.4632 24.3404 17.2768 23.5269L29.7768 11.0269C30.5904 10.2133 31.9095 10.2133 32.7231 11.0269Z",
    fill: "black",
    fillOpacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaEsquerda);
export default __webpack_public_path__ + "static/media/setaEsquerda.003ab2bc946b3c18234947d4e76852d7.svg";
export { ForwardRef as ReactComponent };